// Check if active url contains the provided string
export const activePageCheck = (str, url) => {
  return url.indexOf(str) > -1;
};
